/**
 * 런타임 동적 키(서버 meta 응답값 등 컴파일타임에 알 수 없는 키)를 안전하게 번역한다.
 * 키가 메시지에 존재하면 번역값을, 없으면 fallback(보통 원문 값)을 반환한다.
 *
 * 동적 키는 next-intl 의 키 union 으로 컴파일타임 검증이 불가능해 단언이 불가피한데,
 * 그 단언을 이 헬퍼 한 곳에만 격리한다. 호출부는 캐스트 없이 사용한다.
 * (고정 enum 키는 값 타입을 literal union 으로 좁혀 캐스트 없이 컴파일타임 검증되므로
 *  이 헬퍼를 쓰지 않는다.)
 *
 * 보간이 필요한 경우 values 를 넘긴다(예: zod 검증 메시지 키 + {max}).
 *
 * @example
 *   const t = useTranslations('meta');
 *   safeT(t, `video.ratio.${ratio}`, ratio); // 번역 누락 시 ratio 원문 노출
 *   safeT(t, firstError, firstError, { max: 10 }); // 보간값 동반
 */
export function safeT(
  t: unknown,
  key: string,
  fallback: string,
  values?: Record<string, string | number>,
): string {
  const translate = t as ((
    key: string,
    values?: Record<string, string | number>,
  ) => string) & {
    has: (key: string) => boolean;
  };
  return translate.has(key) ? translate(key, values) : fallback;
}
